import { FC } from 'react';
import { Col, Row } from 'react-bootstrap';
import styled from 'styled-components';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import {
  FieldSkeleton,
  SelectSkeleton,
  TextareaSkeleton,
  CheckboxSkeleton,
  ButtonSkeleton,
  TableSkeleton
} from '../../../common/components/Skeleton/FormSkeleton';
import { Hr } from '../../../common/elements/Hr/Hr';

export const AutopsyProtocolFormSkeleton: FC = () => {
  return (
    <StyledForm>
      <Row>
        <Col xl={6} lg={12} md={12}>
          <Row className="align-items-center">
            <Col lg={8} md={12}>
              <Skeleton width={150} height={16} style={{ marginBottom: '8px' }} />
            </Col>
            <Col lg={4} md={12}>
              <CheckboxSkeleton />
            </Col>
          </Row>
          <Row>
            <Col xl={10} lg={10} md={12}>
              <FieldSkeleton />
            </Col>
          </Row>
          <Row>
            <Col xl={6} lg={6} md={12}>
              <FieldSkeleton />
            </Col>
          </Row>
          <Row>
            <Col xl={10} lg={10} md={12}>
              <SelectSkeleton />
            </Col>
          </Row>
        </Col>
        <Col xl={6} lg={12} md={12}>
          <Row>
            <Col md={12}>
              <SelectSkeleton />
              <Skeleton width={150} height={14} style={{ marginTop: '-16px' }} />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <TableSkeleton />
            </Col>
          </Row>
        </Col>
      </Row>
      <Hr />
      <Row>
        <Col xl={6} lg={6} md={12}>
          <Row>
            <Col lg={8} md={12}>
              <FieldSkeleton />
            </Col>
            <Col lg={4} md={12}>
              <CheckboxSkeleton />
            </Col>
          </Row>
          <Row>
            <Col lg={8} md={12}>
              <TextareaSkeleton rows={2} />
            </Col>
            <Col lg={4} md={12}>
              <FieldSkeleton />
            </Col>
          </Row>
          <Row>
            <Col lg={10} md={12}>
              <TextareaSkeleton rows={2} />
            </Col>
          </Row>
          <Hr />
          {/* Diagnosis tabs skeleton */}
          <Row>
            <Col md={12}>
              <Skeleton height={40} style={{ marginBottom: '16px' }} />
              <SelectSkeleton />
              <SelectSkeleton />
              <SelectSkeleton />
            </Col>
          </Row>
          <Hr />
          <Row>
            <Col md={12}>
              <FieldSkeleton />
            </Col>
          </Row>
        </Col>
        <Col xl={6} lg={6} md={12}>
          <SelectSkeleton />
          <SelectSkeleton />
          <SelectSkeleton />
          <SelectSkeleton />
          <SelectSkeleton />
          <SelectSkeleton />
          <SelectSkeleton />
          <Row>
            <Col md={12}>
              <TextareaSkeleton rows={5} />
            </Col>
          </Row>
        </Col>
      </Row>
      <Hr />
      <Row>
        <Col md={12}>
          <StyledActionButtonsWrapper>
            <StyledFlexWrapper>
              <ButtonSkeleton width={100} />
              <ButtonSkeleton width={100} />
            </StyledFlexWrapper>
            <ButtonSkeleton width={180} />
            <StyledFlexWrapper>
              <ButtonSkeleton width={120} />
              <ButtonSkeleton width={100} />
            </StyledFlexWrapper>
          </StyledActionButtonsWrapper>
        </Col>
      </Row>
    </StyledForm>
  );
};

const StyledForm = styled.div`
  padding-top: 1.5rem;
`;

const StyledFlexWrapper = styled.div`
  display: flex;
  gap: 1rem;
`;

const StyledActionButtonsWrapper = styled(StyledFlexWrapper)`
  justify-content: space-between;
  width: 100%;
`;
